import { ChangeDetectorRef, Component, VERSION } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/security/auth.service';

import { Comentario } from 'src/app/shared/model/tickets/comentario.model';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { TicketsEstatus } from 'src/app/utilerias/enums/tickets-estatus.enum';
import swal from 'sweetalert2';

import { TicketMejora } from 'src/app/shared/model/tickets/ticketMejora.model';
import { Prioridad } from 'src/app/shared/model/tickets/prioridad.model';
import { EmpresaLista } from 'src/app/shared/model/tickets/empresaLista.model';
import { TicketsService } from '../../tickets.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { MatFormField, MatLabel, MatError, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelectionList, MatListOption } from '@angular/material/list';

@Component({
    selector: 'app-mejoras-tickets',
    standalone: true,
    templateUrl: './mejoras-tickets.component.html',
    styleUrls: ['./mejoras-tickets.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, NgIf, MatFormField, MatSelect, NgFor, MatOption, MatLabel, MatError, MatInput, MatSelectionList, MatListOption]
})
export class MejorasTicketsComponent {
  //version = VERSION.full;
  nombreCompleto: string;
  
  prioridades: Prioridad[];
  prioridadesFiltradas: Prioridad[];
  empresas: EmpresaLista[];
  empresaSeleccionada: EmpresaLista;
  empresaSelect: boolean =false;
  tickets: Tickets;
  mejora: TicketMejora;
  comentario: Comentario;
  options: FormGroup;
  evidencia = [];
  selectedOptions = [];
  index: number;
  btnElimina: boolean = true;
  btnAgrega: boolean = false;
  totalsize = 0;

  constructor( private fb: FormBuilder, public modal: MatDialogRef<MejorasTicketsComponent>,
    private ticketsService: TicketsService, private authS: AuthService,
    // Sin zone.js, lo que llega del servidor solo se pinta si se avisa (markForCheck).
    private cambios: ChangeDetectorRef) { }

  ngOnInit() {
    this.comentario = new Comentario();
    this.tickets = new Tickets();
    this.mejora = new TicketMejora();
    this.options = this.fb.group({
      proyectoCtrl:['', Validators.required],
      empresaCtrl: ['', Validators.required],
      justificacionCtrl: ['', Validators.required],
      descripcionCtrl: ['', Validators.required],
      prioridadCtrl: ['', Validators.required],
    });
  
    // this.options.valueChanges.subscribe(selectedValue => {
    //   console.log(selectedValue)     // Sirve para visualizar los cambios del formulario de manera dinamica
    // })

    this.ticketsService.consultarPrioridad().subscribe(resp => {
      if (resp != null) {
        this.prioridades = resp.list;
        this.prioridadesFiltradas=resp.list;
        this.cambios.markForCheck();
      }
    });

    this.ticketsService.consultarEmpresa(UrlConstantes.consultarEmpresaLista).subscribe(res => {
      if (res != null) {
        this.empresas = res.list;
        this.cambios.markForCheck();
        if(this.empresas.length ==1){
          this.empresaSeleccionada=this.empresas[0];
          this.empresaSelect=true;
          this.options.controls.empresaCtrl.setValue( this.empresaSeleccionada);
        }
      }
    });

    this.buscarUsuario();

  }

  subirEv() {
    const input = (<HTMLInputElement>document.getElementById('nameFile'));
    if (input.files.length > 0) {
      for (let i = 0; i <= input.files.length - 1; i++) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        this.evidencia.push(input.files[i]);
      }
    }
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
  }

  elimina() {
    for (let i = 0; i < this.selectedOptions.length; ++i) {
      this.index = this.evidencia.findIndex(item => item.name == this.selectedOptions[i].name);
      this.evidencia.splice(this.index, 1);
    }
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
  }

  limpiar(): void {
    this.options.reset();
    this.buscarUsuario();
    if(this.empresas.length == 1 ){
      this.empresaSeleccionada = this.empresas[0];
      this.empresaSelect = true;
      this.options.controls.empresaCtrl.setValue( this.empresaSeleccionada);
    }
    //this.inputAsuntoCtrl.nativeElement.focus();
  }

  onNgModelChange($event) {
    if ($event.length != 0) {
      this.btnElimina = false;
    } else {
      this.btnElimina = true;
    }
  }

  salir() {
    this.modal.close();
  }

  guardar(): void {
    this.tickets.asunto = "SOLICITUD DE MEJORA"
    this.tickets.id_empresaDirigido = this.empresaSeleccionada.id;
    this.mejora.ticket = this.tickets;    
    console.log(this.mejora);
    console.log(this.comentario);
    
    
    // if(this.empresaSeleccionada==null){
    //   swal.fire({
    //     title: '¡Es necesario seleccionar una empresa! ',
    //     timer: 5000,
    //     type: 'warning',
    //     showConfirmButton: true
    //   }).then(responeMsg => {
    //   });
    //   return;
    // }
    
    this.ticketsService.guardarMejoraTicket(this.mejora).subscribe(res => {
      if (res != null) {
        swal.fire({
          title: '¡Se ha generado la solicitud de Mejora! Con el folio: '+res.ticket.id_ticket,
          timer: 5000,
          icon: 'success',
          showConfirmButton: true
        }).then(responeMsg => {
          if (res.pCodRetorno === '00000') {
            this.comentario.id_usuario = this.tickets.id_UsuarioSolicito;
            this.comentario.id_estatus = res.ticket.id_estatus;
            this.comentario.id_ticket = res.ticket.id_ticket;
            this.ticketsService.guardarComentario(this.comentario).subscribe(resComment => {
              for (let i = 0; i < this.evidencia.length; i++) {
                const formData = new FormData();
                formData.append('file', this.evidencia[i], "$" + resComment.id + "$" + this.evidencia[i].name);
                this.ticketsService.uploadEvidencia(formData).subscribe();
              }
            });
            this.modal.close(this.tickets);
          } else {
            //this.inputAsuntoCtrl.nativeElement.focus();
          }
        });
      } else {
        swal.fire({
          title: ' Fallo la generación del Ticket.',
          timer: 5000,
          icon: 'error',
          showConfirmButton: true
        });
      }
    });
  }

  buscarUsuario() {
    this.authS.getSesion().subscribe(res => {
      this.tickets.nombreSolicitante = res.persona.nombre.concat(" ").concat(res.persona.apellidoPaterno).concat(" ").concat(res.persona.apellidoMaterno);
      this.tickets.id_UsuarioSolicito = res.usuario.id;
      this.tickets.id_Empresa = res.usuario.idEmpresa;
      this.tickets.id_Corporativo = res.usuario.idCorporativo;
      this.tickets.id_estatus = TicketsEstatus.ABIERTA;
      this.nombreCompleto = res.persona.nombre.concat(" ").concat(res.persona.apellidoPaterno).concat(" ").concat(res.persona.apellidoMaterno);
    });
  }

  orgValueChange() {
    this.prioridadesFiltradas = [];
    for (let i = 0; i < this.prioridades.length; i++) {
      if(this.prioridades[i].nombre === 'Alta'){
       if(this.tickets.tipoSolicitud === 'Incidencia'){
        this.prioridadesFiltradas.push(this.prioridades[i]);
       }
      }else{
        this.prioridadesFiltradas.push(this.prioridades[i]);
      }
    }
       this.tickets.prioridad=null;
  }

  onCloseClick() {
    this.modal.close();
  }
}
